AFRAME.registerComponent('news-graph-rotation', {
    schema: {
        target: { type: 'selector' },
        speed: { type: 'number', default: 2.0 },
        autoRotateSpeed: { type: 'number', default: 0.0015 },
        is2D: { type: 'boolean', default: false }
    },

    init: function () {
        this.dragging = false;
        this.raycasterEl = null;
        this.initialControllerPos = new THREE.Vector3();
        this.initialTargetQuaternion = new THREE.Quaternion();
        this.initialControllerQuaternion = new THREE.Quaternion();
        this.lastControllerQuat = new THREE.Quaternion();

        this.isMouseDrag = false;
        this.startMouse = { x: 0, y: 0 };
        this.currentMouse = { x: 0, y: 0 };

        this.isRotationLocked = false;
        this.rotationLockAxis = null;
        this.dragStartX = 0;
        this.dragStartY = 0;

        this.onWindowMouseMove = this.onWindowMouseMove.bind(this);
        this.onWindowMouseUp = this.onWindowMouseUp.bind(this);
        this.onWindowTouchStart = this.onWindowTouchStart.bind(this);
        this.onWindowTouchMove = this.onWindowTouchMove.bind(this);
        this.onToggleAutoRotate = this.onToggleAutoRotate.bind(this);
        this.onSetAutoRotate = this.onSetAutoRotate.bind(this);

        this.autoRotateController = null;
        if (window.NewsGraph && window.NewsGraph.NewsGraphAutoRotateController) {
            this.autoRotateController = new window.NewsGraph.NewsGraphAutoRotateController({
                enabled: true,
                speed: this.data.autoRotateSpeed
            });
        }

        window.addEventListener('mousemove', this.onWindowMouseMove);
        window.addEventListener('mouseup', this.onWindowMouseUp);
        window.addEventListener('touchstart', this.onWindowTouchStart, { passive: true });
        window.addEventListener('touchmove', this.onWindowTouchMove, { passive: false });
        window.addEventListener('touchend', this.onWindowMouseUp);
        window.addEventListener('touchcancel', this.onWindowMouseUp);

        this.el.sceneEl.addEventListener('news-graph-toggle-autorotate', this.onToggleAutoRotate);
        this.el.sceneEl.addEventListener('news-graph-set-autorotate', this.onSetAutoRotate);

        this.el.addEventListener('raycaster-intersected', e => {
            this.raycasterEl = e.detail.el;
        });

        this.el.addEventListener('raycaster-intersected-cleared', e => {
            if (!this.dragging) {
                this.raycasterEl = null;
            }
        });

        this.el.addEventListener('triggerdown', () => {
            this.isMouseDrag = false;
            this.startDrag();
        });
        this.el.addEventListener('triggerup', () => this.stopDrag());

        this.el.addEventListener('mousedown', (e) => {
            this.isMouseDrag = !window.AppState || !window.AppState.isTrueVRMode;
            this.startDrag();
        });
    },

    remove: function () {
        window.removeEventListener('mousemove', this.onWindowMouseMove);
        window.removeEventListener('mouseup', this.onWindowMouseUp);
        window.removeEventListener('touchstart', this.onWindowTouchStart);
        window.removeEventListener('touchmove', this.onWindowTouchMove);
        window.removeEventListener('touchend', this.onWindowMouseUp);
        window.removeEventListener('touchcancel', this.onWindowMouseUp);

        if (this.el.sceneEl) {
            this.el.sceneEl.removeEventListener('news-graph-toggle-autorotate', this.onToggleAutoRotate);
            this.el.sceneEl.removeEventListener('news-graph-set-autorotate', this.onSetAutoRotate);
        }
    },

    emitRotationUpdate: function (target) {
        const rotDegY = target.object3D.rotation.y * 180 / Math.PI;
        const rotDegX = target.object3D.rotation.x * 180 / Math.PI;
        const rotDegZ = target.object3D.rotation.z * 180 / Math.PI;
        const rotationValues = { x: rotDegX, y: rotDegY, z: rotDegZ };
        target.emit('update-rotation', rotationValues);
        this.el.sceneEl.emit('update-rotation', rotationValues);
    },

    isAutoRotateEnabled: function () {
        if (!this.autoRotateController) return false;
        return !!this.autoRotateController.enabled;
    },

    setAutoRotateEnabled: function (enabled) {
        if (!this.autoRotateController) return false;
        this.autoRotateController.setSpeed(this.data.autoRotateSpeed);
        const next = this.autoRotateController.setEnabled(enabled);
        this.el.sceneEl.emit('news-graph-autorotate-changed', { active: next });
        return next;
    },

    onToggleAutoRotate: function () {
        this.setAutoRotateEnabled(!this.isAutoRotateEnabled());
    },

    onSetAutoRotate: function (e) {
        const active = !!(e && e.detail && e.detail.active);
        this.setAutoRotateEnabled(active);
    },

    getTarget: function () {
        return this.data.target || this.el;
    },

    onWindowMouseMove: function (e) {
        this.currentMouse.x = e.clientX;
        this.currentMouse.y = e.clientY;
    },

    onWindowMouseUp: function () {
        this.stopDrag();
    },

    onWindowTouchStart: function (e) {
        if (e.touches.length === 1) {
            this.currentMouse.x = e.touches[0].clientX;
            this.currentMouse.y = e.touches[0].clientY;
        }
    },

    onWindowTouchMove: function (e) {
        if (e.touches.length === 1) {
            this.currentMouse.x = e.touches[0].clientX;
            this.currentMouse.y = e.touches[0].clientY;
        }
    },

    getControllerPosition: function () {
        if (!this.raycasterEl) return null;

        const controllerPos = new THREE.Vector3();
        this.raycasterEl.object3D.getWorldPosition(controllerPos);
        return controllerPos;
    },

    startDrag: function () {
        const target = this.getTarget();
        if (!target || !target.object3D) return;
        if (!this.raycasterEl && !this.isMouseDrag) return;

        this.dragging = true;

        if (this.isMouseDrag) {
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
            this.dragStartX = this.currentMouse.x;
            this.dragStartY = this.currentMouse.y;
            this.isRotationLocked = false;
            this.rotationLockAxis = null;
            this.el.sceneEl.emit('drag-move-start');
        } else {
            const controllerPos = this.getControllerPosition();
            if (!controllerPos) return;
            this.initialControllerPos.copy(controllerPos);
            if (this.raycasterEl && this.raycasterEl.object3D) {
                this.initialControllerQuaternion.copy(this.raycasterEl.object3D.quaternion);
                this.lastControllerQuat.copy(this.raycasterEl.object3D.quaternion);
            }
            this.isRotationLocked = false;
            this.rotationLockAxis = null;
        }

        this.setAutoRotateEnabled(false);
        this.initialTargetQuaternion.copy(target.object3D.quaternion);
    },

    stopDrag: function () {
        if (this.dragging && this.isMouseDrag) {
            this.el.sceneEl.emit('drag-move-end');
        }
        this.dragging = false;

        if (this.raycasterEl) {
            const intersection = this.raycasterEl.components.raycaster.getIntersection(this.el);
            if (!intersection) {
                this.raycasterEl = null;
            }
        }
    },

    tick: function () {
        const target = this.getTarget();
        if (!target || !target.object3D) return;

        if (this.data.is2D) {
            const THREE = window.THREE || AFRAME.THREE;
            target.object3D.rotation.x = 0;
            target.object3D.rotation.y = THREE.MathUtils.degToRad(45);
            return;
        }

        if (!this.dragging) {
            if (this.autoRotateController) {
                this.autoRotateController.setSpeed(this.data.autoRotateSpeed);
                const didRotate = this.autoRotateController.tick(target.object3D);
                if (didRotate) {
                    this.emitRotationUpdate(target);
                }
            }
            return;
        }

        const LOCK_THRESHOLD = 5;

        if (this.isMouseDrag) {
            if (!this.isRotationLocked) {
                const diffX = Math.abs(this.currentMouse.x - this.dragStartX);
                const diffY = Math.abs(this.currentMouse.y - this.dragStartY);
                if (diffX > LOCK_THRESHOLD || diffY > LOCK_THRESHOLD) {
                    this.isRotationLocked = true;
                } else {
                    return;
                }
            }
            const sensitivity = 0.01 * this.data.speed;
            const deltaX = (this.currentMouse.x - this.startMouse.x) * sensitivity;
            const deltaY = (this.currentMouse.y - this.startMouse.y) * sensitivity;

            if (Math.abs(deltaX) > 0.0001 || Math.abs(deltaY) > 0.0001) {
                const quatX = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), deltaY);
                const quatY = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), deltaX);

                const worldDeltaQuat = quatY.multiply(quatX);
                const currentWorldQuat = new THREE.Quaternion();
                target.object3D.getWorldQuaternion(currentWorldQuat);
                const newWorldQuat = worldDeltaQuat.multiply(currentWorldQuat);
                const parentWorldQuat = new THREE.Quaternion();
                if (target.object3D.parent) {
                    target.object3D.parent.getWorldQuaternion(parentWorldQuat);
                    const newLocalQuat = parentWorldQuat.invert().multiply(newWorldQuat);
                    target.object3D.quaternion.copy(newLocalQuat);
                } else {
                    target.object3D.quaternion.copy(newWorldQuat);
                }
            }
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
        } else {
            if (!this.raycasterEl || !this.raycasterEl.object3D) return;
            const currentControllerQuat = this.raycasterEl.object3D.quaternion.clone();
            const initialControllerQuatInv = this.initialControllerQuaternion.clone().invert();
            const totalDeltaQuat = currentControllerQuat.clone().multiply(initialControllerQuatInv).invert();
            const totalDeltaEuler = new THREE.Euler().setFromQuaternion(totalDeltaQuat, 'YXZ');

            const diffX = Math.abs(totalDeltaEuler.y);
            const diffY = Math.abs(totalDeltaEuler.x);
            const LOCK_THRESHOLD_RAD = 0.02;

            if (!this.isRotationLocked) {
                if (diffX > LOCK_THRESHOLD_RAD || diffY > LOCK_THRESHOLD_RAD) {
                    this.isRotationLocked = true;
                    this.rotationLockAxis = diffX > diffY ? 'x' : 'y';
                } else {
                    return;
                }
            }

            const lastControllerQuatInv = this.lastControllerQuat.clone().invert();
            const incrementalDeltaQuat = currentControllerQuat.clone().multiply(lastControllerQuatInv).invert();
            const incrementalDeltaEuler = new THREE.Euler().setFromQuaternion(incrementalDeltaQuat, 'YXZ');

            const controllerAmplification = 2.0 * this.data.speed;
            const deltaX = incrementalDeltaEuler.y * controllerAmplification;
            const deltaY = incrementalDeltaEuler.x * controllerAmplification;

            if (Math.abs(deltaX) > 0.0001 || Math.abs(deltaY) > 0.0001) {
                let quatX = new THREE.Quaternion();
                let quatY = new THREE.Quaternion();

                if (this.rotationLockAxis === 'y') {
                    quatX.setFromAxisAngle(new THREE.Vector3(1, 0, 0), deltaY);
                } else if (this.rotationLockAxis === 'x') {
                    quatY.setFromAxisAngle(new THREE.Vector3(0, 1, 0), deltaX);
                }

                const worldDeltaQuat = quatY.multiply(quatX);
                const currentWorldQuat = new THREE.Quaternion();
                target.object3D.getWorldQuaternion(currentWorldQuat);
                const newWorldQuat = worldDeltaQuat.multiply(currentWorldQuat);
                const parentWorldQuat = new THREE.Quaternion();
                if (target.object3D.parent) {
                    target.object3D.parent.getWorldQuaternion(parentWorldQuat);
                    const newLocalQuat = parentWorldQuat.invert().multiply(newWorldQuat);
                    target.object3D.quaternion.copy(newLocalQuat);
                } else {
                    target.object3D.quaternion.copy(newWorldQuat);
                }
            }
            this.lastControllerQuat.copy(currentControllerQuat);
        }

        this.emitRotationUpdate(target);
    }
});
